import Icon from "hardcover-ui/components/Icon";
import faFlagCheckered from "icons/regular/flag-checkered.svg";
import faBook from "icons/regular/book.svg";
import ReportSeriesButton from "components/ReportDropdown/ReportSeriesButton";
import pluralize from "lib/pluralize";
import Badge from "hardcover-ui/components/Badge";
import Heading from "hardcover-ui/components/Heading";
import AboutSeries from "components/series/AboutSeries";
import { PageSerializersSeriesShow } from "types/serializers";
import Container from "hardcover-ui/components/Container";
import ExpandingText from "components/ui/ExpandingText";

export default function SeriesHeader({ series }: { series: PageSerializersSeriesShow }) {
  return (
    <Container variant="layout" size="md">
      <div className="flex items-center gap-4">
        <div className="mb-4">
          <div className="flex justify-between items-baseline leading-8">
            <div className="flex items-center gap-2">
              <Badge className="space-x-1" variant="secondary" size="md">
                <Icon icon={faBook} size="sm" />
                <span>
                  {series.primaryReleasedBooksCount}{" "}
                  {pluralize("book", series.primaryReleasedBooksCount)} in series
                </span>
              </Badge>
              {series.unrelesedBooksCount > 0 && (
                <Badge variant="secondary" className="space-x-1">
                  <Icon icon={faFlagCheckered} size="sm" />
                  <span>{series.unrelesedBooksCount} {pluralize("unreleased book", series.unrelesedBooksCount)}</span>
                </Badge>
              )}
              {series.isCompleted === true && (
                <Badge variant="accent" className="space-x-2">
                  <Icon icon={faFlagCheckered} size="sm" />
                  <span>All books published</span>
                </Badge>
              )}
            </div>
            <ReportSeriesButton series={series} />
          </div>
          <Heading className="my-1">{series.name}</Heading>
          <AboutSeries series={series} />
        </div>

      </div>

      {series.description && series.description.length > 0 && (
        <ExpandingText text={series.description} lines={6} />
      )}
    </Container>
  );
}